import Image from 'ui/src/components/Image';
import React from 'react';

export default function TrustBar() {
  return (
    <div
      id="trust-bar"
      className="bg-site-primary-25 text-site-neutrals-900 site-paragraph-m -mt-[1.875rem] mb-8 flex h-16 w-full items-center justify-center space-x-4 px-6 py-2"
    >
      <Image
        src="https://assets.bairesdev.com/image/upload/www/static/nishant-r-portrait_xvykwh"
        alt="Nishant R."
        width={64}
        height={64}
        className="mdS:-mb-1 sm:mb-0 md:mb-0"
      />
      <p className="md:site-paragraph-m site-paragraph-s flex flex-col">
        &quot;Of the 15 engineers on my team, a third are from BairesDev&quot;
        <span className="text-site-neutrals-700 site-paragraph-s">
          Nishant R. - <b>Pinterest</b>
        </span>
      </p>
      <div className="border-site-primary-50 mdS:block hidden h-10 w-1 border-l" />
      <p className="site-paragraph-s mdS:block hidden">
        500+ companies trust us with
        <br /> their{' '}
        <a href="https://www.bairesdev.com/software-development-services/" className="underline">
          software development
        </a>{' '}
        needs.
      </p>
    </div>
  );
}
